/**
 * These are the Date Time format used in our application.
 * To change format pattern in any locale, create class which extends DateTimeFormatDefault overwrite format.
 */
export interface DateTimeFormatType {
  DATE: string;
  DATE_WITHOUT_YEAR: string;
  DATE_WITHOUT_MONTH: string;
  DATE_WITH_WEEKDAY_WITHOUT_YEAR: string;
  DATE_WITH_WEEKDAY: string;
  DATE_TIME: string;
  DATE_TIME_WITHOUT_YEAR: string;
  DATE_TIME_WITH_WEEKDAY: string;
  DATE_TIME_WITH_WEEKDAY_WITHOUT_YEAR: string;
  TIME_ONLY: string;
  DATE_ONLY: string;
  MONTH_ONLY: string;
  YEAR_ONLY: string;
  WEEKDAY_ONLY: string;
}

/**Default Date Time pattern, This is as per en-US locale.*/
export class DateTimeFormatDefault implements DateTimeFormatType {
  DATE = "MMM d, yyyy";
  DATE_WITHOUT_YEAR = "MMM d";
  DATE_WITHOUT_MONTH = "d, yyyy";
  DATE_WITH_WEEKDAY_WITHOUT_YEAR = "E, MMM d";
  DATE_WITH_WEEKDAY = "E, MMM d, yyyy";
  DATE_TIME = "MMM d, yyyy p";
  DATE_TIME_WITHOUT_YEAR = "MMM d, p";
  DATE_TIME_WITH_WEEKDAY = "E, MMM d, yyyy p";
  DATE_TIME_WITH_WEEKDAY_WITHOUT_YEAR = "E, MMM d, p";
  TIME_ONLY = "p";
  DATE_ONLY = "d";
  MONTH_ONLY = "MMM";
  YEAR_ONLY = "yyyy";
  WEEKDAY_ONLY = "E";
}

export class DateTimeFormatEnGB extends DateTimeFormatDefault {
  /**Example of different date pattern based on locale */
  //DATE = "d MMM yyyy"
}
